// Generic (non-crop-engine) client-side tools shown in the hub / home / sitemap.
export const GENERIC_TOOLS = [
  {
    slug: "pdf-shipping-label-cropper",
    path: "/tools/pdf-shipping-label-cropper",
    name: "PDF Shipping Label Cropper",
    icon: "FileSearch",
    promise: "Not sure which cropper to use? Pick your marketplace and crop the invoice out in seconds.",
  },
  {
    slug: "merge-pdf",
    path: "/tools/merge-pdf",
    name: "Merge PDF",
    icon: "FilePlus2",
    promise: "Combine several PDFs into one file, in the order you choose.",
  },
  {
    slug: "rearrange-pdf",
    path: "/tools/rearrange-pdf",
    name: "Rearrange PDF",
    icon: "MoveVertical",
    promise: "Reorder, delete and rotate PDF pages, then download.",
  },
  {
    slug: "product-image-resizer",
    path: "/tools/product-image-resizer",
    name: "Product Image Resizer",
    icon: "ImageDown",
    promise: "Resize product images to preset or custom sizes in your browser.",
  },
  {
    slug: "amazon-product-image-resizer",
    path: "/tools/amazon-product-image-resizer",
    name: "Amazon Product Image Resizer",
    icon: "ImagePlus",
    promise: "Resize photos to Amazon's 1000×1000px main-image requirement.",
  },
  {
    slug: "meesho-product-image-resizer",
    path: "/tools/meesho-product-image-resizer",
    name: "Meesho Product Image Resizer",
    icon: "ImagePlus",
    promise: "Resize photos to a Meesho-friendly square crop before you upload.",
  },
  {
    slug: "profit-calculator",
    path: "/profit-calculator",
    name: "Profit Calculator",
    icon: "Calculator",
    promise: "Calculate real profit per order after fees, shipping, ads and GST — with break-even price.",
  },
];
